<template>
  <div
    :class="[
      'clearfix',
      'msg-card',
      'msg-card-' + direction,
      { 'msg-card-full-width': fullWidth },
    ]"
  >
    <div :class="['chat-box-' + direction]">
      <slot />
    </div>
    <div class="loading" v-if="loading || error">
      <van-loading v-if="loading" size="20" class="color" />
      <van-icon
        @click="handleError"
        v-if="error"
        size="20"
        class="color"
        name="warning"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    direction: {
      type: String,
      default: "right",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleError() {
      this.$emit("error");
    },
  },
};
</script>

<style lang="less" scoped>
.msg-card {
  display: flex;
  align-items: center;
  white-space: normal;
  word-break: break-all;
  overflow: auto;
  &.msg-card-full-width {
    .chat-box-left {
      max-width: 100%;
      width: 100%;
    }
  }
  .loading {
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
  }
  /deep/ img {
    max-width: 100%;
  }
  /deep/ video {
    max-width: 100%;
  }
  &.msg-card-right {
    flex-direction: row-reverse;
  }
  &.msg-card-middle {
    justify-content: center;
    .chat-box-middle {
      max-width: 160%;
      border-radius: 3px;
      background: #d8d8d8;
      padding: 6px 10px;
      font-size: 12px;
      color: #797a8c;
      .chat-main-box {
        padding: 0;
        background: none;
      }
    }
  }
}
.color {
  color: @gold;
}
</style>
